/**
 * Module Access Status Enum
 * Represents the different states of access for paid modules
 */
export enum AccessStatus {
  /** User has active access to the module */
  ACTIVE = 'active',
  /** User's subscription has expired */
  EXPIRED = 'expired',
  /** User has never had a subscription or it's missing */
  MISSING = 'missing',
}


